import { getData } from "./axiosConfig"

export const getAllProducts = async (id, page = '1') => {
    if (id) {
        return await getData(`products/get-all-product?category_id=${id}?page=${page}`)
    }
    else {
        return await getData(`products/get-all-product?page=${page}`)
    }
}

export const getSingleProducts = async (id) => {
    return await getData(`products/product/${id}`)
}

export const getCategories = async () => {
    return await getData(`/categories`)
}